
const checkIn = {
  namespaced: true,
  state: {
    params: {},
    searchInfo: {},
    travelerList: [],
    flightInfo: {},
    productInfo:{},
  },
  getters: {//getters属性理解为所有组件的computed属性, 也就是计算属性
    params: (state) => {
      return state.params || {}
    },
    searchInfo: (state) => {
      return state.searchInfo || {}
    },
    flightInfo: (state) => {
      return state.flightInfo || {}
    },
    travelerList: (state) => {
      return state.travelerList || []
    },
    productInfo: (state) => {
      return state.productInfo || []
    }
  },
  mutations: { //mutaions理解为store中的methods
    params: (state, payload) => {
      Object.assign(state.params , payload)
    },
    searchInfo (state, payload) {
      Object.assign(state.searchInfo , payload)
    },
    flightInfo (state, payload) {
      state.flightInfo=payload
    },
    travelerList (state, payload) {
      state.travelerList = payload
    },
    setProductInfo (state, payload) {
      state.productInfo = payload
    },
    CLEAR_ALL (state, payload) { 
      state.searchInfo = {}
      state.params = {}
      state.flightInfo = {}
      state.travelerList = []
      state.productInfo = {}
    }
  },
  actions: { //添加actions actions中可以包含异步操作
    // minusPriceAsync( context, payload ) {
    // setTimeout( () => {
    //     context.commit( 'minusPrice', payload ); //context提交
    // }, 2000)
    // }
  }
}
export default checkIn